export const TOC_STORAGE_KEY = 'course_toc_open';
